// Studyo Today Backend
// Package studyo.today.schools.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/schools/v1/resources/course_section_details.proto (package studyo.today.schools.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_studyo_today_schools_v1_resources_student } from "./student_pb.js";
import { file_studyo_today_schools_v1_resources_teacher } from "./teacher_pb.js";

/**
 * Describes the file studyo/today/schools/v1/resources/course_section_details.proto.
 */
export const file_studyo_today_schools_v1_resources_course_section_details = /*@__PURE__*/
  fileDesc("Cj5zdHVkeW8vdG9kYXkvc2Nob29scy92MS9yZXNvdXJjZXMvY291cnNlX3NlY3Rpb25fZGV0YWlscy5wcm90bxIhc3R1ZHlvLnRvZGF5LnNjaG9vbHMudjEucmVzb3VyY2VzIsYBChRDb3Vyc2VTZWN0aW9uRGV0YWlscxIVCg1zdHVkZW50X2NvdW50GAEgASgFEhsKE3RvZGF5X3N0dWRlbnRfY291bnQYAiABKAUSPAoIdGVhY2hlcnMYAyADKAsyKi5zdHVkeW8udG9kYXkuc2Nob29scy52MS5yZXNvdXJjZXMuVGVhY2hlchI8CghzdHVkZW50cxgEIAMoCzIqLnN0dWR5by50b2RheS5zY2hvb2xzLnYxLnJlc291cmNlcy5TdHVkZW50QimqAiZTdHVkeW8uVG9kYXkuU2Nob29scy5HcnBjLlYxLlJlc291cmNlc2IGcHJvdG8z", [file_studyo_today_schools_v1_resources_student, file_studyo_today_schools_v1_resources_teacher]);

/**
 * Describes the message studyo.today.schools.v1.resources.CourseSectionDetails.
 * Use `create(CourseSectionDetailsSchema)` to create a new message.
 */
export const CourseSectionDetailsSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schools_v1_resources_course_section_details, 0);

